import { Button } from '@/components/Button/Button';
import { ListItem } from '@/components/List/ListItem';
import { Ionicons } from '@expo/vector-icons';
import { useAppTranslation } from '@hooks/useAppTranslation';
import React from 'react';
import { Modal, Pressable } from 'react-native';
import { SizableText, useTheme, XStack, YStack } from 'tamagui';

interface AddReportCreationModeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectInAppForm: () => void;
  onSelectCsvImport: () => void;
}

export const AddReportCreationModeModal = ({
  isOpen,
  onClose,
  onSelectInAppForm,
  onSelectCsvImport,
}: AddReportCreationModeModalProps): React.ReactElement => {
  const { t } = useAppTranslation();
  const theme = useTheme();
  const iconColor = theme.color?.val;

  return (
    <Modal
      animationType="fade"
      transparent
      visible={isOpen}
      onRequestClose={onClose}
    >
      <YStack
        flex={1}
        backgroundColor="$shadow"
        alignItems="center"
        justifyContent="center"
        padding="$true"
      >
        <Pressable
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          }}
          onPress={onClose}
        />

        <YStack
          width="100%"
          maxWidth={720}
          backgroundColor="$background"
          borderRadius="$true"
          padding="$true"
          gap="$true"
          zIndex="$1"
        >
          <XStack alignItems="center" justifyContent="space-between">
            <SizableText size="$h6" fontFamily="$bold">
              {t('reportCreation.creationModeModal.title')}
            </SizableText>

            <Button
              variant="ghost"
              icon={<Ionicons name="close" size={24} color={theme.color.val} />}
              onPress={onClose}
              maxWidth={30}
              padding={0}
            />
          </XStack>

          <SizableText size="$7">
            {t('reportCreation.creationModeModal.description')}
          </SizableText>

          <YStack gap="$2">
            <ListItem
              title={t('reportCreation.creationModeModal.inAppForm')}
              onPress={onSelectInAppForm}
              iconBefore={
                <Ionicons
                  name="document-text-outline"
                  size={20}
                  color={iconColor}
                />
              }
              iconAfter={
                <Ionicons name="chevron-forward" size={18} color={iconColor} />
              }
            />
            <ListItem
              title={t('reportCreation.creationModeModal.csvImport')}
              onPress={onSelectCsvImport}
              iconBefore={
                <Ionicons
                  name="document-attach-outline"
                  size={20}
                  color={iconColor}
                />
              }
              iconAfter={
                <Ionicons name="chevron-forward" size={18} color={iconColor} />
              }
            />
          </YStack>
        </YStack>
      </YStack>
    </Modal>
  );
};
